import React, {useEffect, useState} from "react";
import {Title} from "../../../../../../stories/Title/Title";
import Edit from "../../../../../../images/EditBlue.svg";
import DeleteButton from "../../../../../../images/DeleteRed.svg";
import Reorder from "../../../../../../images/ReOrder.svg";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import {useLazyQuery, useMutation} from "@apollo/client";
import {CheckProjectAnyInitHeader, GetProjectsHeaders} from "../../../masters/projects/queries/queries";
import {
  AtsProjectHeaders,
  DeleteProjectHeaderResult,
  DeleteProjectHeaderVar,
  GetProjectsHeadersResult,
  GetProjectsHeadersVar,
  ReOrderProjectHeaderResult,
  ReOrderProjectHeaderVar,
} from "../../../masters/projects/queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import {
  DeleteProjectHeader,
  ReOrderProjectHeader,
} from "../../../masters/projects/queries/mutations";
import {emptyMessage} from "../../../../../../utils/constants";
import {msgType, opWithIdType} from "../../../../../../utils/types";
import {Operation} from "../../../../../../utils/Enum.types";
import MessageModal from "../../../../../../customComponents/MessageModal";

interface StatesType {
  operation: opWithIdType;
  setOperation: React.Dispatch<React.SetStateAction<opWithIdType>>;
}
interface Props {
  states: StatesType;
}

interface DraggedItem {
  item: AtsProjectHeaders;
  index: number;
}
const List = ({states}: Props) => {
  const [deleteModal, setDeleteModal] = useState(false);

  const {customer_id, projectID} = useUrlParams();

  const {operation, setOperation} = states;

  const {user_details} = useLoggedInUserDetails();

  const [message, setMessage] = useState<msgType>(emptyMessage);

  const [localItems, setLocalItems] = useState<AtsProjectHeaders[]>([]);

  const [reorder, setReorder] = useState(false);

  const [draggedItem, setDraggedItem] = useState<DraggedItem | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);
  const [newItemText, setNewItemText] = useState("");

  const handleDragStart = (
    e: React.DragEvent<HTMLDivElement>,
    item: AtsProjectHeaders,
    index: number
  ): void => {
    setDraggedItem({item, index});
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (
    e: React.DragEvent<HTMLDivElement>,
    index: number
  ): void => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    setDragOverIndex(index);
  };

  const handleDrop = (
    e: React.DragEvent<HTMLDivElement>,
    dropIndex: number
  ): void => {
    e.preventDefault();

    if (draggedItem && draggedItem.index !== dropIndex) {
      const newItems: AtsProjectHeaders[] = [...localItems];
      const draggedItemData: AtsProjectHeaders = newItems[draggedItem.index];

      // Remove the dragged item
      newItems.splice(draggedItem.index, 1);

      // Insert at new position
      newItems.splice(dropIndex, 0, draggedItemData);

      setLocalItems(newItems);
    }

    setDraggedItem(null);
    setDragOverIndex(null);
  };

  const [DeleteHeader] = useMutation<
    DeleteProjectHeaderResult,
    DeleteProjectHeaderVar
  >(DeleteProjectHeader, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [ReOrder, {loading: reorderLoading}] = useMutation<
    ReOrderProjectHeaderResult,
    ReOrderProjectHeaderVar
  >(ReOrderProjectHeader, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  const [GetProjectHeads, {data, error, loading}] = useLazyQuery<
    GetProjectsHeadersResult,
    GetProjectsHeadersVar
  >(GetProjectsHeaders);

  useEffect(() => {
    if (customer_id && projectID)
      GetProjectHeads({
        variables: {
          customerID: customer_id,
          projectID: projectID,
        },
      }).then(({data}) => {
        if (data) {
          setLocalItems(data.GetProjectsHeaders);
        }
      });
  }, [projectID, customer_id, user_details.id, data, GetProjectHeads]);

  const handleDetele = (projectHeaderID: number) => {
    setDeleteModal(!deleteModal);
    if (customer_id)
      DeleteHeader({
        variables: {
          projectHeaderID,
          customerID: customer_id,
          user_details,
        },
        refetchQueries: [
          {
            query: GetProjectsHeaders,
            variables: {
              customerID: customer_id,
              projectID: projectID,
            },
          },
          {
            query: CheckProjectAnyInitHeader,
            variables: {
              customerID: customer_id,
              projectID: projectID,
            },
          },
        ],
      }).then(({data}) => {
        if (data) {
          setMessage({
            flag: true,
            message: "Delete Project Header successfully",
            operation: Operation.DELETE,
          });
        }
      });
  };

  const handleDragLeave = (): void => {
    setDragOverIndex(null);
  };

  const handleSaveOrder = () => {
    if (customer_id) {
      ReOrder({
        variables: {
          customerID: customer_id,
          user_details,
          input: localItems.map((res, index) => ({
            projectHeaderID: res.id,
            idx: index + 1,
          })),
        },
        refetchQueries: [
          {
            query: GetProjectsHeaders,
            variables: {
              customerID: customer_id,
              projectID: projectID,
            },
          },
        ],
      }).then(({data}) => {
        if (data) {
          setMessage({
            flag: true,
            message: "Re-Order Successful",
            operation: Operation.UPDATE,
          });
        }
      });
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setReorder(false);
    }
    if (operation.operation !== Operation.CREATE) {
      setOperation({
        id: 0,
        operation: Operation.CREATE,
      });
    }
    setMessage(emptyMessage);
  };

  return (
    <div className="add-wp-ts__list">
      <div className="add-wp-ts__list--title">
        <Title variant="subtitle1">List of Parameter / Fields</Title>
      </div>
      <div className="add-wp-ts__list--table">
        {data && !loading ? (
          localItems.map((label, index) => {
            return (
              <div
                className="add-wp-ts__list--table--li"
                draggable
                onDragStart={(e) => handleDragStart(e, label, index)}
                onDragOver={(e) => handleDragOver(e, index)}
                onDragLeave={handleDragLeave}
                onDrop={(e) => handleDrop(e, index)}
              >
                <label>{label.header}</label>
                <div className="add-wp-ts__list--table--li--flex">
                  <span>{label.dataType}</span>
                  <img
                    src={Edit}
                    alt=""
                    onClick={() => {
                      setOperation({
                        id: label.id,
                        operation: Operation.UPDATE,
                      });
                    }}
                  />
                  <img
                    src={DeleteButton}
                    alt=""
                    onClick={() => {
                      setOperation({
                        id: label.id,
                        operation: Operation.DELETE,
                      });
                      setDeleteModal(!deleteModal);
                    }}
                  />
                </div>
              </div>
            );
          })
        ) : error && !loading ? (
          <b className="nodata">{error.message}</b>
        ) : loading ? (
          <b className="nodata">{"Loading..."}</b>
        ) : (
          <></>
        )}
      </div>
      {reorder ? (
        <button
          className="add-wp-ts__list--re-order"
          disabled={reorderLoading}
          onClick={handleSaveOrder}
        >
          Save-order <img src={Reorder} alt="" />
        </button>
      ) : localItems.length > 1 ? (
        <button
          className="add-wp-ts__list--re-order"
          disabled={reorderLoading}
          onClick={() => setReorder(!reorder)}
        >
          Re-order <img src={Reorder} alt="" />
        </button>
      ) : (
        <></>
      )}
      <DeleteModal
        id={operation.id}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDetele}
      />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default List;
